const cacheableContext = {
  headers: {
    'x-cache': 1,
  },
}

export function getCacheableContext() {
  return cacheableContext
}
